<div class="page-innder-body portlet light ">
  <div class="portlet-body">
    <div class="table-toolbar">
      <div class="row">
        <div class="col-md-12">
          <p-toolbar styleClass="px-0">
            <div class="p-toolbar-group-start" style="font-size:x-large;">{{ 'productSync.productSynchronization' | transloco }}</div>
            <div class="p-toolbar-group-end">
            </div>
          </p-toolbar>

        </div>
      </div>
    </div>
    <div class="row mt-2 p-2">
      <div class="col-9 border px-3 py-3 bg-white  shadow-sm">
        <div class="row">

          <!-- Header -->
          <div class="d-flex justify-content-between align-items-center mb-2 px-2">
            <div class="fw-bold fs-6 ">
              <i class="pi pi-images color-artwork me-1"></i> {{ 'productSync.availableArtworks' | transloco }}
            </div>
          </div>
          <!-- Helper Text -->
          <div class="text-muted small px-2 mb-3">
            {{ 'productSync.availableArtworksHelp' | transloco }}
          </div>

          @for (product of galleryProducts; track product) {
            <div class="col-2 mb-3">
              <div class="d-flex flex-column align-items-center rounded-3 shadow bg-light border h-100 cursor-pointer"
                (click)="selectInventory(product); $event.stopPropagation()" style="transition: transform 0.2s;"
                onmouseover="this.style.transform='scale(1.03)';" onmouseout="this.style.transform='scale(1)';"
                [title]="'productSync.clickToRemoveFromConsignment' | transloco: { name: product.Product.Name }">
                <div
                  class="image-container d-flex justify-content-center align-items-center p-1 border-bottom w-100 position-relative"
                  [title]="'productSync.clickToViewDetails' | transloco: { name: product.Product.Name }">
                  <!-- Circle Icon Top Right -->
                  <div class="position-absolute top-0 end-0 m-2  "
                    (click)="openProductDialog(product.Product.Id); $event.stopPropagation()">
                    <i class="fa fa-info-circle fs-4 "></i>
                  </div>
                  <img [src]="product.Product.ResizedImageUrl ? product.Product.ResizedImageUrl : 'assets/images/No-Image.png'"
                    class="img-fluid rounded object-fit: contain; w-100" />
                  </div>
                  <div class="text-center px-2 py-2 w-100">
                    <div class="text-uppercase fw-semibold text-dark text-truncate small">
                      {{ product.Product.Name }}
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- No Artworks Found -->
            @if (galleryProducts.length === 0) {
              <div class="d-flex justify-content-center text-muted py-5">
                <i class="pi pi-image me-2"></i> {{ 'productSync.noGalleryAcceptedProducts' | transloco }}
              </div>
            }

          </div>
        </div>
        <div class="col-3 border py-3 bg-light shadow-sm">
          <div class="row">
            <!-- Header -->
            <div class="d-flex flex-column mb-3 px-2">
              <div class="fw-bold fs-6 text-center">
                🧺 {{ 'productSync.selectedArtworks' | transloco }}


              </div>
              <!-- Helper Text -->
              @if (selectedGalleryProductsInventory.length > 0) {
                <div class="text-muted small text-center px-2 mb-3">
                  {{ 'productSync.selectedArtworksHelp' | transloco }}
                </div>
              }
              <div class="d-flex justify-content-center mb-2">
                @if (selectedGalleryProductsInventory.length > 0) {
                  <span
                    class="badge text-white d-inline-flex align-items-center justify-content-center"
                    style="background-color: #178d9b; font-weight: 700; width: 30px; height: 30px; border-radius: 50%;">
                    {{ selectedGalleryProductsInventory.length }}
                  </span>
                }
              </div>
              @if (selectedGalleryProductsInventory.length > 0) {
                <div class="d-flex justify-content-center mt-3 mb-3">
                  <button pButton type="button" [label]="'productSync.syncProducts' | transloco" icon="pi pi-sync"
                  class="p-button-outlined p-button-sm text-success" (click)="onSyncProductPlatform()"></button>
                </div>
              }
              @if (selectedGalleryProductsInventory.length > 0) {
                <div class="text-muted text-center small mb-3">
                  {{ 'productSync.onceDoneSelecting' | transloco }}
                </div>
              }
            </div>

            <!-- No products selected -->
            @if (selectedGalleryProductsInventory.length === 0) {
              <div
                class="d-flex justify-content-center text-muted py-4">
                <i class="pi pi-info-circle me-1 mt-1"></i>
                {{ 'productSync.noProductsSelectedYet' | transloco }}
              </div>
            }

            @for (product of selectedGalleryProductsInventory; track product; let i = $index) {
              <div class="col-6 mb-3 drag-item">
                <div class="d-flex flex-column align-items-center rounded-3 shadow bg-light border h-100 cursor-pointer"
                  (click)="moveToCurrentInventory(product); $event.stopPropagation()"
                  style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.03)';"
                  onmouseout="this.style.transform='scale(1)';"
                  [title]="'productSync.clickToRemoveFromConsignment' | transloco: { name: product.Product.Name }">
                  <div class="image-container d-flex justify-content-center align-items-center p-1 border-bottom w-100 position-relative"
                    [title]="'productSync.clickToViewDetails' | transloco: { name: product.Product.Name }">
                    <!-- Circle Icon Top Right -->
                    <div class="position-absolute top-0 end-0 m-2"
                      (click)="openProductDialog(product.Product.Id); $event.stopPropagation()">
                      <i class="fa fa-info-circle fs-4"></i>
                    </div>
                    <img [src]="product.Product.ProductImgUrl || 'assets/images/No-Image.png'"
                      class="img-fluid rounded object-fit: contain; w-100" />
                    </div>
                    <div class="text-center px-2 py-2 w-100">
                      <div class="text-uppercase fw-semibold text-dark text-truncate small">
                        {{ product.Product.Name }}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>




    <p-dialog [header]="'productSync.artworkDetail' | transloco" [(visible)]="isArtworkDetailDailogVisible" [modal]="true" [style]="{'width': '600px'}"
      (onHide)="oncloseArtworkDetailDailog()">
      @if (currentArtwork && currentArtwork.Product) {
        <div class="d-flex flex-column w-100 p-2">
          <div class="d-flex">
            <div class="custom-img-container mt-2 position-relative">
              @if (currentArtwork) {
                @if (currentArtwork.IsConsignedProduct && !currentArtwork.IsProductSold) {
                  <span class="badge bg-danger position-absolute start-1 top-1 my-1 ms-1"
                  >{{ 'productSync.consigned' | transloco }}</span>
                }
                @if (currentArtwork.IsProductSold && !currentArtwork.IsConsignedProduct) {
                  <span class="badge bg-danger position-absolute start-1 top-1 my-1 mx-1"
                  >{{ 'productSync.sold' | transloco }}</span>
                }
                @if (!currentArtwork.IsConsignedProduct && !currentArtwork.IsProductSold) {
                  <span class="badge bg-success position-absolute start-1 top-1 my-1 ms-1"
                  >{{ 'productSync.available' | transloco }}</span>
                }
              }
              <div class="custom-img-container">
                <img
                  [src]="currentArtwork.Product.ProductImgUrl ? currentArtwork.Product.ProductImgUrl : 'assets/images/No-Image.png'"
                  class="rounded-cube border" width="250" height="250" alt="Product Image"
                  [ngClass]="{ 'disabled-img': currentArtwork.IsProductSold }">
                </div>
              </div>
              <div class="d-flex flex-column ps-2">
                <div class="text-uppercase fw-semibold d-flex align-items-center">
                  <!-- <span *ngIf="currentArtwork.Product.SerialNumber" class="badge rounded-pill text-bg-danger me-2">
                  {{ currentArtwork.Product.SerialNumber }}
                </span> -->
                <a href="javascript:void(0);" class="text-dark fw-bold fs-2" pTooltip="{{ currentArtwork.Product.Name }}">
                  {{ currentArtwork.Product.Name }}
                </a>
              </div>
              <div>
                <!-- <span *ngIf="currentArtwork.Product.SerialNumber" class="badge rounded-pill text-bg-danger me-2">
                {{ currentArtwork.Product.SerialNumber }}
              </span> -->
              {{ currentArtwork.Product.ArtistShortDescription }}
            </div>
            <div class="mt-1">
              @if (currentArtwork.ArtistName) {
                <div class="d-flex flex-row justify-content-between">
                  <div class="d-flex align-items-center cursor-pointer">
                    <div class="fw-semibold text-uppercase">{{ 'productSync.artist' | transloco }} </div>
                    <div class="ms-1">{{ currentArtwork.ArtistName }}</div>
                  </div>
                </div>
              }
              @if (currentArtwork.ConsignmentName) {
                <div class="d-flex flex-row justify-content-between">
                  <div class="d-flex align-items-center cursor-pointer">
                    <div class="fw-semibold text-uppercase">{{ 'productSync.consignment' | transloco }} </div>
                    <div class="ms-1">{{ currentArtwork.ConsignmentName }}</div>
                  </div>
                </div>
              }
              @if (currentArtwork.DispatchedDate) {
                <div class="d-flex flex-row justify-content-between">
                  <div class="d-flex align-items-center cursor-pointer">
                    <div class="fw-semibold text-uppercase">{{ 'productSync.dispatchedDate' | transloco }} </div>
                    <div class="ms-1">{{ currentArtwork.DispatchedDate | date: 'dd/MM/yyyy' }}
                    </div>
                  </div>
                </div>
              }
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center cursor-pointer">
                  <div class="fw-semibold text-uppercase">{{ 'productSync.dateAccepted' | transloco }} </div>
                  <div class="ms-1">{{ currentArtwork.GalleryAcceptedDate | date: 'dd/MM/yyyy' }}
                    @if (currentArtwork.AcceptedBeforeXDays === 0) {
                      {{ 'productSync.today' | transloco }}
                    }
                    @if (currentArtwork.AcceptedBeforeXDays) {
                      {{ 'productSync.daysAgo' | transloco: { days: currentArtwork.AcceptedBeforeXDays } }}
                    }
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center cursor-pointer">
                  <div class="fw-semibold text-uppercase">
                    @if (!currentArtwork.IsConsignedProduct && !currentArtwork.IsProductSold) {
                      {{ 'productSync.artistRevenue' | transloco }}
                    }
                    @if (currentArtwork.IsConsignedProduct && !currentArtwork.IsProductSold) {
                      {{ 'productSync.retailPrice' | transloco }}
                    }
                    @if (currentArtwork.IsProductSold) {
                      {{ 'productSync.soldPrice' | transloco }}
                    }
                  </div>
                  <div class="ms-1">
                    @if (!currentArtwork.IsConsignedProduct && !currentArtwork.IsProductSold) {
                      {{
                      currentArtwork.Product.ArtistRevenue | currency: 'USD' : 'symbol' : '1.2-2' }}
                    }
                    @if (currentArtwork.IsConsignedProduct && !currentArtwork.IsProductSold) {
                      {{
                      currentArtwork.RetailPrice | currency: 'USD' : 'symbol' : '1.2-2' }}
                    }
                    @if (currentArtwork.IsProductSold) {
                      {{ currentArtwork.ProductSoldPrice | currency: 'USD'
                      :
                      'symbol' : '1.2-2' }}
                    }
                  </div>
                </div>
                @if (currentArtwork.SquarePosProductId || currentArtwork.ShopifyProductId || currentArtwork.WooCommerceProductId || currentArtwork.WixProductId) {
                  <div class="d-flex align-items-center justify-content-end me-4"
                    >
                    <div class="d-flex flex-column align-items-center ">
                      <div class="fw-semibold text-uppercase">
                        <ng-container>{{ 'productSync.syncedOn' | transloco }}</ng-container>
                      </div>
                      <div class="d-flex align-items-center ">
                        @if (currentArtwork.SquarePosProductId) {
                          <div class="cursor-pointer ms-2">
                            <img src="assets/images/square-log.png" [pTooltip]="'productSync.postedToSquareup' | transloco"
                              tooltipPosition="top" alt="square-logo" style="height: 20px;">
                            </div>
                          }
                          @if (currentArtwork.ShopifyProductId) {
                            <div class="cursor-pointer ms-2">
                              <img src="assets/images/shopify-log.png" [pTooltip]="'productSync.postedToShopify' | transloco"
                                tooltipPosition="top" alt="shopify-logo" style="height: 20px;">
                              </div>
                            }
                            @if (currentArtwork.WooCommerceProductId) {
                              <div class="cursor-pointer ms-2">
                                <img src="assets/images/woocommerace-log.png" [pTooltip]="'productSync.postedToWoocommerce' | transloco"
                                  tooltipPosition="top" alt="Woocommerace-log" style="height: 20px;">
                                </div>
                              }
                              @if (currentArtwork.WixProductId) {
                                <div class="cursor-pointer ms-2">
                                  <img src="assets/images/wix-logo.png" [pTooltip]="'productSync.postedToWix' | transloco"
                                    tooltipPosition="top" alt="Wix-log" style="height: 20px;">
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </p-dialog>
          <!-- Currency Exchange Dialog -->
          <p-dialog [(visible)]="displayCurrencyDialog" [modal]="true" [closable]="true" [header]="'productSync.platformCurrencySettings' | transloco"
            [style]="{ width: '650px' }"  (onHide)="onCurrencyDialogHide()">

            <!-- Selected Platforms Section -->
            @if (selectedPlatform.length > 0) {
              <div class="selected-platforms-section p-3 mb-3 bg-light rounded">
                <h5 class="fw-bold mb-2">{{ 'productSync.selectedPlatforms' | transloco }}</h5>
                <div class="d-flex flex-wrap gap-3">
                  @for (platform of selectedPlatform; track platform) {
                    @if (getSelectedStoreDetails(platform); as store) {
                      <div class="d-flex align-items-center gap-2">
                        <img [src]="store.image" [alt]="store.name" style="height: 25px;">
                        <span>{{ store.name }}</span>
                      </div>
                    }
                  }
                </div>
              </div>
            }

            <!-- Loading State -->
            @if (isLoading) {
              <div class="d-flex justify-content-center align-items-center flex-column"
                style="min-height: 200px;">
                <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
                <p class="mt-3 text-muted" style="font-size: 1.2rem; font-weight: normal;">{{ 'productSync.loadingExchangeRates' | transloco }}</p>
              </div>
            }

            <!-- Dialog Content (Visible After Loading) -->
            @if (!isLoading) {
              <div class="dialog-content p-2">
                <!-- Information Section -->
                <div class="mb-4">
                  <p class="text-muted mb-2" style="font-size: 1.1rem; line-height: 1.5; font-weight: normal;">
                    {{ 'productSync.defaultPricingCurrencySetTo' | transloco }}
                    @if (platforms?.BasePlateform) {
                      {{ 'productSync.basePlatformInArtflowPro' | transloco: { basePlatform: platforms.BasePlateform } }}
                    }
                  </p>
                  <p class="text-muted" style="font-size: 1.1rem; line-height: 1.5; font-weight: normal;">
                    {{ 'productSync.exchangeRatesFetchedFrom' | transloco }}
                    <strong><a href="https://openexchangerates.org/" target="_blank">openexchangerates.org</a></strong>
                    {{ 'productSync.orEnteredManually' | transloco }}
                  </p>
                </div>
                <!-- Info Alert -->
                <div class="alert alert-info mb-4" style="font-size: 1rem; border-left: 4px solid #17a2b8; padding: 0.75rem;">
                  <strong>{{ 'productSync.note' | transloco }}</strong> {{ 'productSync.differentPlatformsCurrencies' | transloco }}
                </div>
                <!-- Exchange Rates Table -->
                <div class="table-responsive">
                  <table class="table table-striped table-bordered table-hover">
                    <thead class="thead-light">
                      <tr>
                        <th>{{ 'productSync.platform' | transloco }}</th>
                        <th>{{ 'productSync.currency' | transloco }}</th>
                        <th>{{ 'productSync.exchangeRate' | transloco }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (platform of platforms?.IntegratedPlateformCurrencyExchangeRate; track platform) {
                        <tr>
                          <!-- Show only platform name in full column span if currencies are same -->
                          @if (!platform.IsPlateformCurrencyIsDifferent) {
                            <td colspan="3">{{ platform.Plateform }}</td>
                          } @else {
                            <td>{{ platform.Plateform }}</td>
                            @if (platform.ResponseObject?.Success) {
                              <td>{{ platform.TargetCurrencySymbol || 'N/A' }}</td>
                              <td>{{ platform.ExchangeRate | number: '1.2-2' }}</td>
                            }
                            @if (!platform.ResponseObject?.Success) {
                              <td colspan="2" class="text-danger">
                                {{ platform.ResponseObject.ResponseMessage || 'Currency data not available' }}
                              </td>
                            }
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }

            <!-- Footer Actions -->
            <ng-template pTemplate="footer">
              <div class="d-flex justify-content-end p-2">
                <!-- Button: Continue without Rate (Secondary) -->
                <p-button [label]="'productSync.continueWithoutRate' | transloco" [outlined]="true" severity="secondary" [disabled]="isLoading"
                  (onClick)="acceptConsignmentProducts($event)">
                </p-button>

                <!-- Button: Continue with Rate (Success) -->
                <p-button type="button" [outlined]="true" severity="success" class="p-button-sm ms-2" [label]="'productSync.continueWithRate' | transloco" [disabled]="isLoading"
                  (onClick)="acceptConsignmentProducts($event)">
                </p-button>
              </div>
            </ng-template>
          </p-dialog>

          <p-dialog [showHeader]="true" [header]="'productSync.artworkSynchronization' | transloco" [(visible)]="isProfileDialogVisible" [modal]="true"
            [style]="{ 'width': '780px' }">
            <div class="p-4">

              <!-- Header Description -->
              <p class="mb-4 fs-5 text-muted">
                {{ 'productSync.manageConfigureSyncHelp' | transloco }}
              </p>

              <!-- Platform Section (Shared Styles) -->
              @if (isSquarePos) {
                <div class="d-flex justify-content-between align-items-center mb-3 p-3 rounded"
                  style="border: 1px solid #e9ecef; background: #f8f9fa;">
                  <div class="d-flex align-items-center">
                    @if (squareUpAccount) {
                      <img src="assets/images/square-log.png" alt="SquareUp Logo" class="me-3"
                        style="height: 24px;" />
                    }
                    <div class="text-muted">
                      @if (!squareUpAccount) {
                        {{ 'productSync.connectSquarePosPrompt' | transloco }}
                      }
                      @if (squareUpAccount) {
                        {{ 'productSync.connectedSquarePos' | transloco }}
                      }
                    </div>
                  </div>
                  <div>
                    @if (!squareUpAccount) {
                      <button pButton type="button" class="p-button-outlined p-button-sm p-button-danger"
                        [label]="'productSync.connect' | transloco" icon="pi pi-credit-card" (click)="onConnectSquareupPosAccount()"
                      [disabled]="isFreePlanUser"></button>
                    }
                    @if (squareUpAccount) {
                      <i class="pi pi-check text-success fs-4"></i>
                    }
                  </div>
                </div>
              }

              <!-- Repeat Block for Shopify -->
              @if (isShopify) {
                <div class="d-flex justify-content-between align-items-center mb-3 p-3 rounded"
                  style="border: 1px solid #e9ecef; background: #f8f9fa;">
                  <div class="d-flex align-items-center">
                    @if (shopifyAccount) {
                      <img src="assets/images/shopify-log.png" alt="Shopify Logo" class="me-3"
                        style="height: 24px;" />
                    }
                    <div class="text-muted">
                      @if (!shopifyAccount) {
                        {{ 'productSync.connectShopifyPrompt' | transloco }}
                      }
                      @if (shopifyAccount) {
                        {{ 'productSync.connectedShopify' | transloco }}
                      }
                    </div>
                  </div>
                  <div>
                    @if (!shopifyAccount) {
                      <button pButton type="button" class="p-button-outlined p-button-sm p-button-danger"
                        [label]="'productSync.connect' | transloco" icon="pi pi-credit-card" (click)="onShowShopifyConnectionDailog()"
                      [disabled]="isFreePlanUser"></button>
                    }
                    @if (shopifyAccount) {
                      <i class="pi pi-check text-success fs-4"></i>
                    }
                  </div>
                </div>
              }

              <!-- WooCommerce -->
              @if (isWoocommerce) {
                <div class="d-flex justify-content-between align-items-center mb-3 p-3 rounded"
                  style="border: 1px solid #e9ecef; background: #f8f9fa;">
                  <div class="d-flex align-items-center">
                    @if (wooCommerceAccount) {
                      <img src="assets/images/woocommerace-log.png" alt="WooCommerce Logo" class="me-3"
                        style="height: 24px;" />
                    }
                    <div class="text-muted">
                      @if (!wooCommerceAccount) {
                        {{ 'productSync.connectWoocommercePrompt' | transloco }}
                      }
                      @if (wooCommerceAccount) {
                        {{ 'productSync.connectedWoocommerce' | transloco }}
                      }
                    </div>
                  </div>
                  <div>
                    @if (!wooCommerceAccount) {
                      <button pButton type="button"
                        class="p-button-outlined p-button-sm p-button-danger" [label]="'productSync.connect' | transloco" icon="pi pi-credit-card"
                      (click)="onShowWoocommerceAccountDailog()" [disabled]="isFreePlanUser"></button>
                    }
                    @if (wooCommerceAccount) {
                      <i class="pi pi-check text-success fs-4"></i>
                    }
                  </div>
                </div>
              }

              <!-- Wix -->
              @if (isWix) {
                <div class="d-flex justify-content-between align-items-center mb-3 p-3 rounded"
                  style="border: 1px solid #e9ecef; background: #f8f9fa;">
                  <div class="d-flex align-items-center">
                    @if (checkAccountExitsOnWix) {
                      <img src="assets/images/wix-logo.png" alt="Wix Logo" class="me-3"
                        style="height: 24px;" />
                    }
                    <div class="text-muted">
                      @if (!checkAccountExitsOnWix) {
                        {{ 'productSync.connectWixPrompt' | transloco }}
                      }
                      @if (checkAccountExitsOnWix) {
                        {{ 'productSync.connectedWix' | transloco }}
                      }
                    </div>
                  </div>
                  <div>
                    @if (!checkAccountExitsOnWix) {
                      <button pButton type="button"
                        class="p-button-outlined p-button-sm p-button-danger" [label]="'productSync.connect' | transloco" icon="pi pi-credit-card"
                      (click)="connectWithWixAccount()" [disabled]="isFreePlanUser"></button>
                    }
                    @if (checkAccountExitsOnWix) {
                      <i class="pi pi-check text-success fs-4"></i>
                    }
                  </div>
                </div>
              }

              <!-- SquareSpace -->
              @if (checkAccountExistOnSquareSpace !== null) {
                <div class="d-flex justify-content-between align-items-center mb-3 p-3 rounded"
                  style="border: 1px solid #e9ecef; background: #f8f9fa;">
                  <div class="d-flex align-items-center">
                    @if (checkAccountExistOnSquareSpace) {
                      <img src="assets/images/squarespace.svg" alt="SquareSpace Logo"
                        class="me-3" style="height: 24px;" />
                    }
                    <div class="text-muted">
                      @if (!checkAccountExistOnSquareSpace) {
                        {{ 'productSync.connectSquareSpacePrompt' | transloco }}
                      }
                      @if (checkAccountExistOnSquareSpace) {
                        {{ 'productSync.connectedSquareSpace' | transloco }}
                      }
                    </div>
                  </div>
                  <div>
                    @if (!checkAccountExistOnSquareSpace) {
                      <button pButton type="button"
                        class="p-button-outlined p-button-sm p-button-danger" [label]="'productSync.connect' | transloco" icon="pi pi-credit-card"
                      (click)="connectWithSquareSpaceAccount()" [disabled]="isFreePlanUser"></button>
                    }
                    @if (checkAccountExistOnSquareSpace) {
                      <i class="pi pi-check text-success fs-4"></i>
                    }
                  </div>
                </div>
              }

              <!-- Free Plan Info -->
              @if (isFreePlanUser) {
                <div class="mt-4 p-3 text-center rounded"
                  style="background: #fff8f0; color: rgba(247, 148, 33, 1);">
                  <i class="pi pi-info-circle fs-3 me-2"></i>
                  <div class="fs-5">
                    {{ 'productSync.freePlanInfo' | transloco }}
                  </div>
                </div>
              }

            </div>
          </p-dialog>


          <p-dialog [header]="'productSync.productSynchronization' | transloco" [(visible)]="showProductSyncronizationDialog" [modal]="true"
            [style]="{'width': '600px'}" (onHide)="resetSelectedData()">
            <div class="row my-4 px-4 p-4">

              <!-- Alert for Free Plan Users -->
              @if (isFreePlanUser) {
                <div class="alert alert-warning p-3 mb-3">
                  <div class="d-flex align-items-center">
                    <i class="pi pi-info-circle text-warning me-3 fs-4"></i>
                    <div class="flex-grow-1">
                      <strong>{{ 'productSync.limitedAccess' | transloco }}</strong> {{ 'productSync.onlyProUsersCanSync' | transloco }}
                      <span class="d-block small">{{ 'productSync.upgradeToUseFeature' | transloco }}</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-start mt-2">
                    <a href="javascript:void(0);" (click)="onUpgradePlan()">
                      <img src="assets/images/upgrade-nag-button-200h.png" width="250" [alt]="'productSync.upgradePlan' | transloco"
                        class="rounded shadow border border-warning" />
                      </a>
                    </div>
                  </div>
                }

                <!-- Instruction Text -->
                <div class="px-0 small text-muted">
                  <i class="fa fa-info-circle me-1"></i> {{ 'productSync.selectPlatformsHelp' | transloco }}
                  <br />
                  <button type="button" pButton class="p-button-warning p-button-outlined p-button-sm mt-3 mb-3"
                    [label]="'productSync.checkConnectionsStatus' | transloco" icon="fa fa-shopping-cart" (click)="showProfileDialog()">
                  </button>
                </div>

                <!-- Platform Selection -->
                <div class="col-12 mt-3">
                  <div class="row fw-bold text-uppercase text-center border-bottom pb-2">

                    <!-- Square POS -->
                    @if (isSquarePos) {
                      <div class="col-2">
                        <div class="d-flex flex-column align-items-center">
                          <img src="assets/images/square-log.png" alt="Square POS Logo" style="height: 20px;" class="mb-1">
                          <div class="text-center small">Square POS</div>
                          <input type="checkbox" [(ngModel)]="selectAllState['Square']" (click)="toggleSelectAll('Square', $event)"
                            class="form-check-input mt-2 border-dark">
                          </div>
                        </div>
                      }

                      <!-- Shopify -->
                      @if (isShopify) {
                        <div class="col-3">
                          <div class="d-flex flex-column align-items-center">
                            <img src="assets/images/shopify-log.png" alt="Shopify Logo" style="height: 20px;" class="mb-1">
                            <div class="text-center small">Shopify</div>
                            <input type="checkbox" [(ngModel)]="selectAllState['Shopify']" (click)="toggleSelectAll('Shopify', $event)"
                              class="form-check-input border-dark">
                            </div>
                          </div>
                        }

                        <!-- WooCommerce -->
                        @if (isWoocommerce) {
                          <div class="col-2">
                            <div class="d-flex flex-column align-items-center">
                              <img src="assets/images/woocommerace-log.png" alt="WooCommerce Logo" style="height: 20px;" class="mb-1">
                              <div class="text-center small">WooCommerce</div>
                              <input type="checkbox" [(ngModel)]="selectAllState['WooCommerce']"
                                (click)="toggleSelectAll('WooCommerce', $event)" class="form-check-input border-dark">
                              </div>
                            </div>
                          }
                          <!-- Wix -->
                          @if (isWix) {
                            <div class="col-2">
                              <div class="d-flex flex-column align-items-center">
                                <img src="assets/images/wix-logo.png" alt="Wix Logo" style="height: 20px;" class="mb-1">
                                <div class="text-center small">Wix</div>
                                <input type="checkbox" [(ngModel)]="selectAllState['Wix']" (click)="toggleSelectAll('Wix', $event)"
                                  class="form-check-input border-dark">
                                </div>
                              </div>
                            }
                            @if (isWix) {
                              <div class="col-3">
                                <div class="d-flex flex-column align-items-center">
                                  <img src="assets/images/squarespace.svg" alt="Wix Logo" style="height: 20px;" class="mb-1">
                                  <div class="text-center small">SquareSpace</div>
                                  <input type="checkbox" [(ngModel)]="selectAllState['SquareSpace']"
                                    (click)="toggleSelectAll('SquareSpace', $event)" class="form-check-input border-dark">
                                  </div>
                                </div>
                              }

                            </div>
                          </div>
                        </div>

                        <!-- Sync Button -->
                        <div class="row my-2 px-3">
                          <button pButton type="button" class="p-button-primary" [label]="'productSync.syncArtworks' | transloco"
                            [disabled]="!isAnyPlatformSelected ||isFreePlanUser" (click)="onSyncArtworksClick()">
                          </button>
                        </div>
                      </p-dialog>


                      <p-dialog [header]="'productSync.woocommerceStore' | transloco" [(visible)]="selectedPlatformDailaog" [modal]="true" [style]="{ width: '500px' }"
                        (onHide)="onWooStoreDialogHide()">
                        <div class="p-4 mb-3">

                          <!-- Store Selection Section -->
                          <div class="d-flex align-items-center mb-4">
                            <img src="assets/images/woocommerace-log.png" alt="WooCommerce Logo" class="me-3"
                              style="width: 32px; height: 32px;" />
                              <div>
                                <h3 class="m-0 fw-bold" style="color: #008080;">{{ 'productSync.yourWoocommerceStores' | transloco }}</h3>
                                <small class="text-muted">{{ 'productSync.selectStoreToConnect' | transloco }}</small>
                              </div>
                            </div>

                            <div class="mb-4 stores-container" style="max-height: 220px; overflow-y: auto; padding-right: 8px;">
                              @for (store of wooCommerceAccountList; track store) {
                                <div class="mb-3 store-item p-3 rounded"
                                  style="border: 1px solid #e9ecef; transition: all 0.2s; background: #f8f9fa;">
                                  <p-radioButton [name]="'woocommerceStore'" [value]="store.Id" [(ngModel)]="selectedWoocommerceStore"
                                    (onClick)="onWoocommerceStoreChange({value: store.Id})" [label]="store.StoreName">
                                  </p-radioButton>
                                </div>
                              }
                              @if (wooCommerceAccountList.length === 0) {
                                <div class="text-center p-4 text-muted">
                                  <i class="pi pi-exclamation-circle me-2"></i>{{ 'productSync.noWoocommerceStoresFound' | transloco }}
                                </div>
                              }
                            </div>

                            <small class="text-muted d-block mt-3 p-3 rounded" style="background: #fff8f0; color: rgba(247, 148, 33, 1);">
                              <i class="pi pi-info-circle me-2"></i>
                              {{ 'productSync.selectingStoreRequired' | transloco }}
                            </small>
                          </div>


                        </p-dialog>
                        <!-- Shopify Store Dialog -->
                        <p-dialog [header]="'productSync.shopifyStore' | transloco" [(visible)]="isShopifyStoreDialogVisible" [modal]="true" [style]="{ width: '500px' }"
                          (onHide)="onShopifyStoreDialogHide()">
                          <div class="p-4 mb-3">
                            <!-- Store Selection Section -->
                            <div class="d-flex align-items-center mb-4">
                              <img src="assets/images/shopify-log.png" alt="Shopify Logo" class="me-3" style="width: 32px; height: 32px;" />
                              <div>
                                <h3 class="m-0 fw-bold" style="color: #008080;">{{ 'productSync.yourShopifyStores' | transloco }}</h3>
                                <small class="text-muted">{{ 'productSync.selectStoreToConnect' | transloco }}</small>
                              </div>
                            </div>

                            <div class="mb-4 stores-container" style="max-height: 220px; overflow-y: auto; padding-right: 8px;">
                              @for (store of shopifyAccountList; track store) {
                                <div class="mb-3 store-item p-3 rounded"
                                  style="border: 1px solid #e9ecef; transition: all 0.2s; background: #f8f9fa;">
                                  <p-radioButton [name]="'shopifyStore'" [value]="store.Id" [(ngModel)]="selectedShopifyStore"
                                    (onClick)="onShopifyStoreChange({value: store.Id})" [label]="store.StoreName">
                                  </p-radioButton>
                                </div>
                              }
                              @if (shopifyAccountList.length === 0) {
                                <div class="text-center p-4 text-muted">
                                  <i class="pi pi-exclamation-circle me-2"></i>{{ 'productSync.noShopifyStoresFound' | transloco }}
                                </div>
                              }
                            </div>

                            <small class="text-muted d-block mt-3 p-3 rounded" style="background: #fff8f0; color: rgba(247, 148, 33, 1);">
                              <i class="pi pi-info-circle me-2"></i>
                              {{ 'productSync.selectingStoreRequired' | transloco }}
                            </small>
                          </div>
                        </p-dialog>

                        <p-dialog [header]="'productSync.squareSpaceStore' | transloco" [(visible)]="isSquareSpaceStoreDialogVisible" [modal]="true" [closable]="false"
                          [style]="{width: '500px'}">
                          <div class="p-4 mb-3">

                            <!-- Store Selection Section -->
                            <div class="d-flex align-items-center mb-4">
                              <img src="assets/images/squarespace.svg" alt="SquareSpace Logo" class="me-3" style="width: 32px; height: 32px;" />
                              <div>
                                <h3 class="m-0 fw-bold" style="color: #008080;">{{ 'productSync.yourSquareSpaceStores' | transloco }}</h3>
                                <small class="text-muted">{{ 'productSync.selectStoreToConnect' | transloco }}</small>
                              </div>
                            </div>

                            <div class="mb-4 stores-container" style="max-height: 220px; overflow-y: auto; padding-right: 8px;">
                              @for (store of squareSpaceStoreDetails; track store) {
                                <div class="mb-3 store-item p-3 rounded"
                                  style="border: 1px solid #e9ecef; transition: all 0.2s; background: #f8f9fa;">
                                  <p-radioButton [name]="'squareSpaceSite'" [value]="store.Id" [(ngModel)]="siteId"
                                    (onClick)="selectSquareSpaceSiteChange($event)" [label]="store.SiteInfo.title">
                                  </p-radioButton>
                                  <small class="text-muted ms-5 d-block">{{store.SiteInfo.domain}}</small>
                                </div>
                              }
                              @if (squareSpaceStoreDetails.length === 0) {
                                <div class="text-center p-4 text-muted">
                                  <i class="pi pi-exclamation-circle me-2"></i>{{ 'productSync.noSquareSpaceStoresFound' | transloco }}
                                </div>
                              }
                            </div>

                            @if (squareSpaceStorePage.length > 0) {
                              <div class="mt-4 mb-3">
                                <label class="form-label fw-bold d-block mb-2" style="color: #008080;">{{ 'productSync.selectProductPage' | transloco }}</label>
                                <small class="text-muted d-block mb-3">{{ 'productSync.chooseWhereProductsAppear' | transloco }}</small>
                                <p-dropdown [options]="squareSpaceStorePage" optionLabel="title" optionValue="id" [(ngModel)]="pageId"
                                  [placeholder]="'productSync.selectAProductPage' | transloco" (onChange)="selectdSquareSpacePageChange($event)" [style]="{width: '100%'}"
                                  inputId="page-select" [panelStyle]="{'border': '1px solid #008080'}">
                                </p-dropdown>
                                <small class="text-muted d-block mt-3">
                                  <i class="pi pi-info-circle me-2"></i>
                                  {{ 'productSync.typicallyShopOrStorePage' | transloco }}
                                </small>
                              </div>
                            }

                          </div>

                          <ng-template pTemplate="footer">
                            <div class="d-flex justify-content-between align-items-center border-top pt-4 pb-2 px-5">
                              <button pButton type="button" [label]="'productSync.cancel' | transloco" class="p-button-outlined p-button-secondary"
                                (click)="onCloseSquareSpaceDialog()">
                                <i class="pi pi-times me-2"></i>
                              </button>
                              <button pButton type="button" [label]="'productSync.confirmSelection' | transloco" class="p-button-primary p-button-outlined"
                                [disabled]="!pageId || !siteId" (click)="confirmSquareSpaceSelection()">
                                <i class="pi pi-check me-2"></i>
                              </button>
                            </div>
                          </ng-template>
                        </p-dialog>

                        <p-dialog [header]="'productSync.syncSummary' | transloco" [(visible)]="showSyncResultsDialog" [modal]="true" [closable]="true"
                          [style]="{ width: '870px' }">

                          <div class="sync-results-container">

                            <!-- Big Status Message -->
                            <div class="overall-status"
                              [ngClass]="{'success': syncResults.overallSuccess, 'error': !syncResults.overallSuccess}">
                              <i class="pi" [ngClass]="syncResults.overallSuccess ? 'pi-check-circle' : 'pi-exclamation-circle'"></i>
                              <div class="status-text">
                                <h3>{{ syncResults.overallSuccess ? 'Sync Complete!' : 'Sync Completed With Issues' }}</h3>
                                <p>{{ syncResults.overallMessage ||
                                (syncResults.overallSuccess ? 'All items processed successfully' : 'Some items need attention') }}</p>
                              </div>
                            </div>

                            <!-- Platform Results -->
                            <div class="platform-results">
                              @for (platform of syncResults.platforms; track platform) {
<div class="platform-result" [ngClass]="{
        'success': platform.success,
        'warning': platform.hasWarnings,
        'error': !platform.success && !platform.hasWarnings
      }">
                                  <div class="platform-header">
          <i class="pi" [ngClass]="{
            'pi-check-circle success-icon': platform.success,
            'pi-exclamation-triangle warning-icon': platform.hasWarnings,
            'pi-times-circle error-icon': !platform.success && !platform.hasWarnings
          }"></i>
                                    <h3>{{platform.name}}</h3>
          <span class="status-badge" [ngClass]="{
            'success-badge': platform.success,
            'warning-badge': platform.hasWarnings,
            'error-badge': !platform.success && !platform.hasWarnings
          }">
                                      {{platform.success ? 'Done' : platform.hasWarnings ? 'Partial' : 'Failed'}}
                                    </span>
                                  </div>
                                  <div class="platform-details">
                                    <p class="sync-status-message">
                                      @if (platform.success) {
                                        {{ 'productSync.allItemsProcessedSuccessfully' | transloco }}
                                      }
                                      @if (platform.hasWarnings) {
                                        {{ 'productSync.completedWithWarnings' | transloco }}
                                      }
                                      @if (!platform.success && !platform.hasWarnings) {
                                        {{ 'productSync.couldNotCompleteSync' | transloco }}
                                      }
                                    </p>
                                    <div class="counters">
                                      @if (platform.newSyncedCount > 0) {
                                        <span class="counter new">
                                          {{ 'productSync.newProductsPushed' | transloco: { count: platform.newSyncedCount } }}
                                        </span>
                                      }
                                      @if (platform.existingSyncedCount > 0) {
                                        <span class="counter existing">
                                          {{ 'productSync.existingProductsUpdated' | transloco: { count: platform.existingSyncedCount } }}
                                        </span>
                                      }
                                    </div>
                                    @if (platform.message) {
                                      <p class="platform-message">
                                        <i class="pi pi-info-circle"></i> {{platform.message}}
                                      </p>
                                    }
                                  </div>
                                </div>
                              }
                            </div>

                            <!-- Help Section -->
                            <div class="help-tip">
                              <i class="pi pi-info-circle"></i>
                              <div>
                                <p><strong>{{ 'productSync.whatStatusesMean' | transloco }}</strong></p>
                                <p>• <strong>{{ 'productSync.newProductsPushedLabel' | transloco }}</strong> {{ 'productSync.newProductsPushedDesc' | transloco }}</p>
                                <p>• <strong>{{ 'productSync.existingProductsUpdatedLabel' | transloco }}</strong> {{ 'productSync.existingProductsUpdatedDesc' | transloco }}</p>
                              </div>
                            </div>
                          </div>

                          <ng-template pTemplate="footer">
                            <button pButton type="button" [label]="'productSync.close' | transloco" (click)="showSyncResultsDialog=false" class="close-button"></button>
                          </ng-template>
                        </p-dialog>

                        <p-dialog [(visible)]="displayUpgreadAccountDialog" [header]="'productSync.upgradeYourAccount' | transloco" [closable]="true" [modal]="true"
                          [style]="{width: '450px'}">
                          <div class="dialog-content">
                            <!-- Warning Section -->
                            <div class="alert alert-warning p-4 rounded-3 border-0 shadow-lg mb-4">
                              <div class="d-flex align-items-center">
                                <i class="pi pi-info-circle text-warning fs-3 me-3"></i>
                                <div>
                                  <strong>{{ 'productSync.upgradeNeeded' | transloco }}</strong>
                                  <p class="mb-2">{{ 'productSync.reachedConsignmentLimit' | transloco }}</p>
                                </div>
                              </div>
                            </div>

                            <!-- Main Content -->
                            <p class="lead p-2">
                              {{ 'productSync.continueAcceptingProducts' | transloco }}
                            </p>

                            <!-- Upgrade CTA -->
                            <div class="text-center mt-4">
                              <a href="javascript:void(0);" (click)="onUpgradeAccount()">
                                <img src="assets/images/upgrade-nag-button-200h.png" width="300" [alt]="'productSync.upgradePlan' | transloco"
                                  class="rounded shadow-lg img-fluid" />
                                </a>
                              </div>
                            </div>
                          </p-dialog>
                          @if (isShopifyConnectionDailogVisible) {
                            <shopify-and-woocommerce-dailog [platform]="'shopify'"
                              [isAddPlatformAccountDailogVisible]="isShopifyConnectionDailogVisible"
                              (onClosePlatformCredentialDailog)="onCloseShopifyConnectionDailog($event)">
                            </shopify-and-woocommerce-dailog>
                          }

                          @if (isAddWoocommerceAccountDailogVisible) {
                            <shopify-and-woocommerce-dailog [platform]="'woocommerce'"
                              [isAddPlatformAccountDailogVisible]="isAddWoocommerceAccountDailogVisible"
                              (onClosePlatformCredentialDailog)="onCloseWoocommerceAccountDailog($event)">
                            </shopify-and-woocommerce-dailog>
                          }

                          @if (isStripeDisplayPlansDialogVisible) {
                            <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripeDisplayPlansDialogVisible"
                              [stripeAllPlans]="stripePlans" (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)">
                            </stripe-payment-plan>
                          }

                          @if (showProductDialog) {
                            <app-product-details-dialog [showProductDialog]="showProductDialog" [productId]="productId"
                              (onClose)="closeProductDialog()">
                            </app-product-details-dialog>
                          }